export function position(e: MouseEvent) {
  return {
    x: e.clientX,
    y: e.clientY,
  }
}

export function stop(e: Event) {
  e.stopPropagation()
}

export function prevent(e: Event) {
  e.cancelable !== false && e.preventDefault()
}

export function stopAndPrevent(e: Event) {
  e.cancelable !== false && e.preventDefault()
  e.stopPropagation()
}

export function noop() {}
